import { date } from "yup";
import { CompanyNameType } from "../../types/commonTypes/companyNameType";
import { LegalEntityTypeOfficiant, Tribunal } from "../../types/commonTypes/legalEntityType";

// raison sociale
export const companyNameInitialState: CompanyNameType = {
    companyName: "",
    clientReference: ""
}

export const officiantInitialState: LegalEntityTypeOfficiant = {
    Denomination:"",
    companyName: "",
    civility: "Monsieur", 
    mode: "",
    nom: "",
    prenom: "",
    legalForm: "",
    capital: 0,
    postalCode: "",
    decisionNature: "",
    city: "",
    address: "",
    additionalAddress: "",
    registrationOffice: "",
    isRcsRegistering: false, 
    cities: [],
    dateofficiant:"",
}

export const tribunalInitialState : Tribunal = {
    greffe:'',
    dateDépot: '',
    numeroRole: ''
}